import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/auth/LoginPage';
import SignupPage from './pages/auth/SignupPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import Dashboard from './pages/dashboards/Dashboard';
import ShipmentsPage from './pages/shipments/ShipmentsPage';
import ProductsPage from './pages/products/ProductsPage';
import OrdersPage from './pages/orders/OrdersPage';
import CatalogsPage from './pages/catalogs/CatalogsPage';
import InvoicesPage from './pages/invoices/InvoicesPage';
import ReportingPage from './pages/reporting/ReportingPage';
import UsersPage from './pages/users/UsersPage';
import SettingsPage from './pages/settings/SettingsPage';
import RolesPage from './pages/roles/RolesPage';
import InsuranceClaimsPage from './pages/claims/InsuranceClaimsPage';
import DesignKitPage from './pages/DesignKitPage';
import PdfViewerPage from './pages/legal/PdfViewerPage';
import AppShell from './components/layout/AppShell';

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/legal/:doc" element={<PdfViewerPage />} />
          <Route path="/uikit" element={<DesignKitPage />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<AppShell />}>
              <Route index element={<Dashboard />} />
              <Route path="shipments" element={<ShipmentsPage />} />
              <Route path="products" element={<ProductsPage />} />
              <Route path="orders" element={<OrdersPage />} />
              <Route path="catalogs" element={<CatalogsPage />} />
              <Route path="invoices" element={<InvoicesPage />} />
              <Route path="reporting" element={<ReportingPage />} />
              <Route path="claims" element={<InsuranceClaimsPage />} />
              <Route path="users" element={<UsersPage />} />
              <Route path="roles" element={<RolesPage />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
